module.exports = __webpack_public_path__ + "img/404.b23591d.webp";